/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type StripePaymentStatus = {
    payment_status: StripePaymentStatus.payment_status;
};
export namespace StripePaymentStatus {
    export enum payment_status {
        NO_PAYMENT_REQUIRED = 'no_payment_required',
        PAID = 'paid',
        UNPAID = 'unpaid',
    }
}

